import { CSSProperties } from 'react';
import './basic-card.scss';
import classNames from 'classnames';

interface IBasicCardProps {
	style?: React.CSSProperties;
	p?: number;
	className?: string;
	noPaddingClass?: boolean;
}

const BasicCard: React.FC<React.PropsWithChildren<IBasicCardProps>> = ({
	style,
	children,
	noPaddingClass = false,
	p = 5,
	className = '',
	...rest
}) => {

	return (
		<div
			className={classNames(`basic-card`, className, { [`padding-${p}`]: !noPaddingClass })}
			style={{
				...style,
				'--basic-card-padding': `${p}px`,
			} as CSSProperties}
			{...rest}
		>
			{children}
		</div>
	);
};

export default BasicCard;
